import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { DashboardList } from '../../screen/DashboardList';
import { NewDashboardContainer } from '../NewDashboardContainer';
import { useScope } from "../SelectProjectCompanyContainer"
import Send from '../../core/communication';
import { sortAlphabetically } from '../../core/utils/manipulateStrings';

const DashboardListContainer = () => {
    const navigation = useNavigate()
    const isUserAdmin = useSelector(state => state.app?.isUserAdmin);
    const [isCreateScreen, setIsCreateScreen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedDashId, setSelectedDashId] = useState({});

    const [data, setData] = useState([])
    const { scope, scopeType } = useScope()

    const loadDash = async () => {
        setIsLoading(true);
        const response = await Send.get(`/projects/${scope?.id}/dashboard`, `scopeType=${scopeType}`);
        setIsLoading(false);
        setData(Array.isArray(response) ? response : []);
    }

    useEffect(() => {
        if(scope?.id) {
            loadDash()
        }
    }, [scope?.id, isCreateScreen])

    useEffect(() => {
        if(scope?.id) {
            setSelectedDashId(null);
            setIsCreateScreen(false);
        }
    }, [scope?.id])

    const toggleScreen = (isNewDash = false) => {
        isNewDash && setSelectedDashId(null);
        setIsCreateScreen(!isCreateScreen); 
    }

    const goToDashboard = () => 
        navigation(`/dashboard/${selectedDashId?.config ? 'dynamic/' : ''}${selectedDashId?.id}`);


    const dashNames = ["Acompanhamento do Diagnóstico Inicial", "Plano de Vida Rural - MSD"]
    const filterCardsDash = scope?.id === "332bdca8-6c13-4ae6-af99-8df8c4fc787d" ? data.filter(item => !dashNames.includes(item.description)) : data
    
    return !isCreateScreen ?
        <DashboardList {...{ data: sortAlphabetically(filterCardsDash, "description"), isUserAdmin, toggleScreen, selectedDashId, setSelectedDashId, goToDashboard, isLoading }} /> :
        <NewDashboardContainer {...{ toggleScreen, selectedDashId }}/>
}

export default DashboardListContainer;